import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import { normalizeLanguage } from '../supportedLanguages';
import { applyTheme } from '../themes/themeBuilder';

var Code = function Code(_ref) {
  var _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'text' : _ref$language,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      codeStyle = _ref.codeStyle,
      _ref$codeTagProps = _ref.codeTagProps,
      codeTagProps = _ref$codeTagProps === void 0 ? {} : _ref$codeTagProps,
      _ref$preTag = _ref.preTag,
      preTag = _ref$preTag === void 0 ? 'span' : _ref$preTag,
      testId = _ref.testId,
      text = _ref.text;

  var _applyTheme = applyTheme(theme),
      inlineCodeStyle = _applyTheme.inlineCodeStyle;

  var props = {
    language: normalizeLanguage(language),
    PreTag: preTag,
    style: codeStyle || inlineCodeStyle,
    codeTagProps: codeTagProps
  };
  return /*#__PURE__*/React.createElement(SyntaxHighlighter, _extends({
    "data-code-lang": language,
    "data-testid": testId
  }, props), text);
};

export default /*#__PURE__*/memo(Code);